import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../components/Layout';

export default function UpgradeSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => navigate('/editor'), 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Layout>
      <div
        style={{
          textAlign: 'center',
          paddingTop: '80px',
          maxWidth: '480px',
          margin: '0 auto',
        }}
      >
        <div style={{ marginBottom: '16px' }}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="11" stroke="#00d4ff" strokeWidth="1.5"/>
            <path d="M7 12l3.5 3.5L17 8" stroke="#00d4ff"
                  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h1
          style={{
            fontSize: '22px',
            fontWeight: 500,
            color: 'var(--text-primary)',
            marginBottom: '8px',
          }}
        >
          Welcome to Pro!
        </h1>
        <p
          style={{
            fontSize: '14px',
            color: 'var(--text-secondary)',
            marginBottom: '24px',
            lineHeight: 1.6,
          }}
        >
          Your subscription is active. You now have unlimited rewrites, full
          history access, and priority response time.
        </p>
        <p style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
          Redirecting to editor in 5 seconds...
        </p>
        <button
          onClick={() => navigate('/editor')}
          style={{
            marginTop: '24px',
            background: 'var(--btn-primary-bg)',
            color: '#fff',
            border: 'none',
            padding: '10px 28px',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: 500,
            cursor: 'pointer',
          }}
        >
          Go to editor →
        </button>
      </div>
    </Layout>
  );
}
